// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".comContent[data-v-d3cb47a6] {\n  position: relative;\n  padding: 0px;\n}\n.comContent .myTabs[data-v-d3cb47a6] {\n  padding: 0 24px;\n  border-bottom: 1px solid #f5f5f5 !important;\n}\n.comContent .center[data-v-d3cb47a6] {\n  margin: 0 24px;\n  height: 100%;\n}\n[data-v-d3cb47a6] .el-badge__content {\n  padding: 0 6px !important;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
